import ProductCategoryPage from "../components/ProductCategoryPage.js";

export default function GrayImportedMarble() {
  return (
    <ProductCategoryPage
      category="Gray"
      seoTitle="Top Grey Imported Marble in Kishangarh India | Premium Grey Italian Marble"
      seoDescription="Top-quality grey imported marble slabs for modern architecture & interiors. Explore our exquisite collection of grey Italian marble in Kishangarh India. Contact Square Feet Marble today! "
      canonical="https://www.squarefeetmarble.com/modern-grey-marble-installation-creating-a-sophisticated-living-space.webp"
    />
  );
}
